import { Modal, Descriptions } from "antd";
import { FC } from "react";
import { Lead } from "../../types/leads";

type Props = {
  visible: boolean;
  onClose: () => void;
  lead: Lead | null;
};

const LeadExtraModal: FC<Props> = ({ visible, onClose, lead }) => {
  if (!lead) return null;

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      title={`Detalhes extras do lead ${lead.name}`}
    >
      <Descriptions bordered column={1}>
        {Object.entries(lead.extra).map(([key, value]) => (
          <Descriptions.Item label={key.split("_").join(" ")} key={key}>
            {value || <i style={{ color: "#999" }}>Vazio</i>}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </Modal>
  );
};

export default LeadExtraModal;
